import React, { Component } from "react";
import PropTypes from 'prop-types';

class SessionExpiredModal extends Component {
    render() {
        const {
            modalId = "sessionExpiredModal",
            title = "Message",
            message = "Your session has expired. Please verify again to proceed",
            buttonText = "Continue",
            logoSrc = "images/modal-logo.svg",
        } = this.props;

        return (
            <dialog className="modal fade model-error" id={modalId} aria-labelledby={`${modalId}Label`} tabIndex="-1" aria-hidden="true" data-keyboard="false" data-backdrop="static">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header"></div>
                        <div className="modal-body">
                            <div className="logo">
                                <img src={logoSrc} alt="logo" className="img-fluid" />
                            </div>
                            <h5 className="modal-title" id={`${modalId}Label`} > {title} </h5>
                            <p className="text-center mt-4">{message}</p>
                        </div>
                        <div className="modal-footer mb-4">
                            <button type="button" className="btn btn-primary" data-dismiss="modal" id="session-expired-button">
                                {buttonText}
                            </button>
                        </div>
                    </div>
                </div>
            </dialog>
        );
    }
}
SessionExpiredModal.propTypes = {
    modalId: PropTypes.string,
    title: PropTypes.string,
    message: PropTypes.string,
    buttonText: PropTypes.string,
    logoSrc: PropTypes.string,
}
export default SessionExpiredModal;
